/** Consistent ordering for platform-specific CPM rows (matches create-campaign UI). */
export const PLATFORM_ORDER = [
  "tiktok",
  "instagramReels",
  "facebookReels",
  "youtubeShorts",
  "youtubeLongForm",
];

/**
 * Rows for display: { key, rate, legacy? }.
 * - legacy: true → single global cpmRate (no per-platform object); show one number without per-platform breakdown.
 * - key set → show icon + rate for that platform.
 */
export function getPerPlatformRateRows(campaign) {
  if (!campaign?.platforms) return [];

  const per = campaign.perPlatformRates;
  const hasExplicitPer =
    per &&
    typeof per === "object" &&
    PLATFORM_ORDER.some((k) => {
      if (!campaign.platforms[k]) return false;
      const v = per[k];
      if (v == null || v === "") return false;
      const n = Number(v);
      return Number.isFinite(n) && n > 0;
    });

  if (!hasExplicitPer) {
    const r = Number(campaign.cpmRate);
    if (!Number.isFinite(r) || r <= 0) return [];
    return [{ key: null, rate: r, legacy: true }];
  }

  const rows = [];
  for (const key of PLATFORM_ORDER) {
    if (!campaign.platforms[key]) continue;
    const raw = per[key];
    const num = raw != null && raw !== "" ? Number(raw) : NaN;
    if (!Number.isFinite(num) || num <= 0) continue;
    rows.push({ key, rate: num });
  }
  return rows;
}

export function getPlatformShortLabel(platformKey) {
  const map = {
    tiktok: "TikTok",
    instagramReels: "Instagram",
    facebookReels: "Facebook",
    youtubeShorts: "YT Shorts",
    youtubeLongForm: "YouTube",
  };
  return map[platformKey] || platformKey;
}
